<template>
  <div>
    <c-search-box ref="searchbox" :isShowSearch="false" @enter="getList">
      <template slot="search">
        <div class="col-xs-6 col-sm-6 col-md-6 col-lg-6 col-xl-6">
          <c-plant type="search" name="plantCd" v-model="searchParam.plantCd" />
        </div>
        <div class="col-xs-6 col-sm-6 col-md-6 col-lg-6 col-xl-6">
          <!-- 안전검사 대상 -->
          <c-select
            type="search"
            itemText="codeName"
            itemValue="code"
            :comboItems="targetCdItems"
            :editable="editable"
            label="안전검사 대상 및 지연"
            name="inspectionSubjectFlag"
            v-model="searchParam.inspectionSubjectFlag">
          </c-select>
        </div>
        <div class="col-xs-6 col-sm-6 col-md-6 col-lg-6 col-xl-6">
          <!-- 자율안전확인신고대상 -->
          <c-select
            type="search"
            itemText="codeName"
            itemValue="code"
            :comboItems="targetCdItems2"
            :editable="editable"
            label="자율안전확인신고대상"
            name="autoSafetyFlag"
            v-model="searchParam.autoSafetyFlag">
          </c-select>
        </div>
        <div class="col-xs-6 col-sm-6 col-md-6 col-lg-6 col-xl-6">
          <!-- 안전인증 대상 -->
          <c-select
            type="search"
            itemText="codeName"
            itemValue="code"
            :comboItems="targetCdItems2"
            :editable="editable"
            label="안전인증 대상"
            name="certificateSubjectFlag"
            v-model="searchParam.certificateSubjectFlag">
          </c-select>
        </div>
      </template>
    </c-search-box>
    <c-table
      ref="table"
      title="유해위험기계기구 목록"
      tableId="equipmentInsp"
      :columns="grid.columns"
      :selection="popupParam.type"
      :data="grid.data"
      :gridHeightAuto="true"
      :checkClickFlag="true"
      rowKey="hhmHazardousMachineryId"
      @linkClick="linkClick"
    >
      <!-- 버튼 영역 -->
      <template slot="table-button">
        <q-btn-group>
          <!-- <c-btn label="검사결과 일괄 업로드" :editable="editable" icon="assignment" /> -->
          <c-btn label="검색" icon="search" @btnClicked="getList" />
          <c-btn label="선택" icon="check" @btnClicked="select" />
        </q-btn-group>
      </template>
      <template v-slot:customArea="{ props, col }">
        <template v-if="col.name === 'inspectionSubjectFlag'">
          <q-chip
            :color="setTagColor(props.row.inspectionSubjectFlag)"
            text-color="white"
            >
            {{setTagName(props.row.inspectionSubjectFlag)}}
          </q-chip>
        </template>

        <template v-if="col.name === 'nextInspectionDate'"> 
          <span>
            {{props.row.nextInspectionDate}}
            <q-badge v-if="props.row.delayFlag === 'A'" color="negative" label="지연" class="blinking" />
          </span>
        </template>
      </template>
    </c-table>
    <c-dialog :param="popupOptions"></c-dialog>
  </div>
</template>

<script>
import selectConfig from '@/js/selectConfig';
export default {
  name: "hazard-equipment-class-pop",
  props: {
    popupParam: {
      type: Object,
      default: function() {
        return {
          type: 'single',
          plantCd: '',
        }
      },
    },
    contentHeight: {
      type: [String, Number],
      default: function() {
        return 'auto'
      },
    }
  },
  data() {
    return {
      grid: {
        columns: [
          {
            name: "plantName",
            field: "plantName",
            label: "사업장",
            style: 'width:100px', 
            align: "center",
            sortable: true,
          },
          {
            name: "emplacementPlace",
            field: "emplacementPlace",
            label: "설비위치",
            style: 'width:200px', 
            align: "left",
            sortable: true,
          },
          {
            name: "machineryClassification",
            field: "machineryClassification",
            label: "설비종류",
            style: 'width:100px', 
            align: "center",
            sortable: true,
          },
          {
            name: "machineryName",
            field: "machineryName",
            label: "형식(규격)",
            style: 'width:200px', 
            align: "left",
            sortable: true,
          },
          {
            name: "volume",
            field: "volume",
            label: "용량",
            style: 'width:100px', 
            align: "right", 
            sortable: true,
          },
          {
            label: '대상',
            align: 'center',
            sortable: false,
            child: [
              {
                name: "inspectionSubjectFlag",
                field: "inspectionSubjectFlag",
                type: 'custom',
                label: "안전검사",
                style: 'width:80px', 
                align: "center",
                sortable: true,
              },
              {
                name: "autoSafetyFlagName",
                field: "autoSafetyFlagName",
                label: "자율안전확인신고",
                style: 'width:60px', 
                align: "center",
                sortable: true,
              },
              {
                name: "certificateSubjectFlagName",
                field: "certificateSubjectFlagName",
                label: "안전인증",
                style: 'width:60px', 
                align: "center",
                sortable: true,
              },
            ]
          },
          {
            name: "inspectionCycleName",
            field: "inspectionCycleName",
            label: "검사주기",
            style: 'width:100px', 
            align: "center",
            sortable: true,
          },
          {
            name: "lastInspectionDate",
            field: "lastInspectionDate",
            label: "최근검사일",
            style: 'width:120px', 
            align: "center",
            sortable: true,
          },
          {
            name: "nextInspectionDate",
            field: "nextInspectionDate",
            label: "차기검사일",
            type: 'custom',
            style: 'width:120px', 
            align: "center",
            sortable: true,
          },
          {
            name: "useFlagName",
            field: "useFlagName",
            label: "사용여부",
            align: "center",
            style: 'width:80px', 
            sortable: true,
          },
        ],
        data: [],
      },
      searchParam: {
        plantCd: null,
        machineryClassification: null,
        // relatedLawList: [],
        inspectionSubjectFlag: null,
        resultCd: null,
        gradeCd: null,
        inspectionKindCd: null,
        inspectionCycle: null,
        departmentDeptCd: '',
        departmentUserId: '',
        startYmd: '',
        endYmd: '',
        useFlag: 'Y'
      },
      typeItems: [],
      editable: true,
      colorItems: [
        { stepperMstCd: 'Y', stepperMstNm: '대상', colorClass: 'green' },
        { stepperMstCd: 'N', stepperMstNm: '비대상', colorClass: 'orange' },
      ],
      targetCdItems: [
        { code: "Y", codeName: "대상" },
        { code: "N", codeName: "비대상" },
        { code: "A", codeName: "지연" },
      ], // 대상여부
      targetCdItems2: [
        { code: "Y", codeName: "대상" },
        { code: "N", codeName: "비대상" },
      ], // 대상여부
      listUrl: '',
      popupOptions: {
        isFull: true,
        target: null,
        title: "",
        visible: false,
        top: "",
        param: {},
        closeCallback: null,
      },
      useFlagItems: [
        { code: 'Y', codeName: '사용' },
        { code: 'N', codeName: '미사용' },
      ],
      isResult: false,
    };
  },
  beforeCreate() {},
  created() {},
  beforeMount() {
    Object.assign(this.$data, this.$options.data());
  },
  mounted() {
    this.init();
  },
  watch: {
    contentHeight() {
      let height = (this.contentHeight - this.$refs['searchbox'].$el.offsetHeight - 50);
      if (height < 400) {
        height = 500;
      }
      this.grid.height = height + 'px'
    }
  },
  beforeDestroy() {},
  methods: {
    init() {
      // role setting
      if (this.popupParam.plantCd) {
        this.searchParam.plantCd = this.popupParam.plantCd;
      }
      // url setting
      this.listUrl = selectConfig.sop.hhm.hazard.check.list.url;
      // list setting
      this.getTypeDetail();
      this.getList();
    },
    getList() {
      // 전체조회
      this.$http.url = this.listUrl;
      this.$http.type = 'GET';
      this.$http.param = this.searchParam;
      this.$http.request((_result) => {
        this.grid.data = _result.data;
      },);
    },
    getTypeDetail() {
      this.$http.url = this.$format(selectConfig.sys.code.mst.list.attr.url, 'HHM_TYPE_CD', 'N');
      this.$http.type = 'GET';
      this.$http.request((_result) => {
        this.typeItems = _result.data;
      },
      () => {
      });
    },
    /* eslint-disable no-unused-vars */ 
    linkClick(row, col, index) {
      this.popupOptions.title = "유해위험기계기구 상세"; // 유해위험기계기구 상세
      this.popupOptions.param = {
        hhmHazardousMachineryId: row.hhmHazardousMachineryId ? row.hhmHazardousMachineryId : '',
      };
      this.popupOptions.target = () =>
        import(`${"./hazardEquipmentClassDetail.vue"}`);
      this.popupOptions.visible = true;
      this.popupOptions.height = '300px';
      this.popupOptions.isFull = true;
      this.popupOptions.closeCallback = this.closePopup;
    },
    closePopup(type) {
      this.popupOptions.target = null;
      this.popupOptions.visible = false;
      this.getList();
    },
    setTagColor(data) {
      if (this.colorItems) {
        let color = this.$_.find(this.colorItems, { code: data }) || this.$_.find(this.colorItems, { stepperMstCd: data })
        return color ? color.attrVal1 || color.colorClass : '';
      } else {
        return ''
      }
    },
    setTagName(data) {
      if (this.colorItems) {
        let color = this.$_.find(this.colorItems, { code: data }) || this.$_.find(this.colorItems, { stepperMstCd: data })
        return color ? color.codeName || color.stepperMstNm : '';
      } else {
        return ''
      }
    },
    select() {
      let selectData = this.$refs['table'].selected;
      if (!selectData || selectData.length === 0) {
        window.getApp.$emit('ALERT', {
          title: '안내', // 안내
          message: '유해위험기계기구를 지정하세요.', // 유해위험기계기구를 지정하세요.
          type: 'warning', // success / info / warning / error
        });
      } else {
        this.$emit('closePopup', selectData);
      }
    },
  },
};
</script>
<style>
.blinking {
  -webkit-animation:blink 3s ease-in-out infinite alternate;
  -moz-animation:blink 3s ease-in-out infinite alternate;
  animation:blink 3s ease-in-out infinite alternate;
}
@-webkit-keyframes blink {
  0% { opacity:0 }
  100% { opacity:1 }
}
@-moz-keyframes blink {
  0% { opacity:0 }
  100% { opacity:1 }
}
@keyframes blink {
  0% { opacity:0 }
  100% { opacity:1 }
}
</style>